<template>
  <div class="fullwidth" id="route">
    <h3 id="anybody">Images for {{ artist.formatted_name }}</h3>
    <div v-for="image in images" :key="image.image_id">
      <router-link  class="image-link"
        :to="getUrl(image)">{{ image.alt }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String
  },
  data() {
    return {
      images: [],
      artist: {}
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    getUrl(image) {
      return this.$k.getImagePermalink(image, this.artist)
    },
    async loadData() {
      this.artist = await this.$store.dispatch('fetchArtist', this.name)
      let res = await this.$apix.post('collections/images', { artist_id: Number(this.artist.artist_id) })
      this.images = res.data
    }
  }
}
</script>

<style>

</style>